import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
import { Container as DashboardMenuContainer } from '../styled';
const ItemStyles = css `
  display: block;

  border-radius: var(--radius-brand);
  padding: var(--space-200) var(--space-400);

  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);

  width: 100%;

  color: var(--text-secondary);

  transition: color var(--motion-duration-100) var(--motion-ease-in-out);
  transition: background var(--motion-duration-100) var(--motion-ease-in-out);

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: var(--bg-secondary);
    }

    &:active {
      background-color: var(--bg-secondary-hover);
    }
  }

  ${mediaQueries.laptop} {
    width: 216px;
  }
`;
export const Container = styled.li `
  & > ${DashboardMenuContainer} {
    margin-top: 2px;
  }
`;
export const Wrapper = styled.div `
  position: relative;

  display: flex;

  gap: var(--space-400);
  align-items: center;

  cursor: pointer;
`;
export const Link = styled(NavLink) `
  ${ItemStyles}

  ${({ $active }) => !$active &&
    css `
      &:hover {
        color: var(--text-primary);
      }
    `};

  ${({ $active }) => $active &&
    css `
      background-color: var(--bg-secondary);
      color: var(--text-primary);
      font-weight: var(--font-weight-medium);
    `};
`;
export const Button = styled.button `
  ${ItemStyles}
`;
export const Label = styled.div `
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; // This is required for "ellipsis" to work properly in a "flex" element
`;
